import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import DisposeRoute from './disposeRoute';

// 懒加载组件
const SaleListDetail = lazy(() => import('@/views/cate/saleList'));
const UserSaleListDetail = lazy(() => import('@/views/user/cate/saleList'));

// 类目相关路由配置
export const cateRoutes: RouteObject[] = [
  // 管理员专用 - Best sell（静态配置）
  {
    path: '/cate',
    element: (
      <DisposeRoute element={<SaleListDetail />} titleId='Best Sell' auth />
    ),
  },
  // Best Sell（后端动态配置，所有用户可见）
  {
    path: '/bestSell',
    element: (
      <DisposeRoute element={<SaleListDetail />} titleId='Best Sell' auth />
    ),
  },
  // 普通用户 - 热销商品列表（独立代码）
  {
    path: '/user/cate',
    element: (
      <DisposeRoute
        element={<UserSaleListDetail />}
        titleId='热销商品列表'
        auth
      />
    ),
  },
];
